import React, { Component } from 'react';
import './../../assets/css/App.css';
import maskLoaderImg from './../../assets/images/loader.gif';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import WarehouseViewTypeEnum from './WarehouseViewTypeEnum';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Package Check in By Operator",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.viewType = WarehouseViewTypeEnum.PackageCheckInTimeByOperator;
    }

    componentDidMount () {
        Service.event.onPackageCheckInTimeByOperator.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }
    // private
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.fetchWarehouseReports(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    // private
    /*_callServiceDownloadFile() {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.downloadCannedAccountReport(searchParams, this.viewType);
    }*/

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        if(this.createdDateStart && this.createdDateEnd){
            this._callServiceFetch(1);
        }else{
            alert("Please select a date range first.");
        }

    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    /*downloadFileAction = () => {
        this._callServiceDownloadFile();
    };*/

    createTables = () => {
        var rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList = this.state.responseTableData.results.map(function (item, index) {
                    var rowColumnComponent = {};

                    rowColumnComponent = <Table key={index}>
                        <TableHead>
                            <tr>
                                <TableHeaderColumn colSpan={3}>{item.firstName} {item.lastName}</TableHeaderColumn>
                            </tr>
                            <tr>
                                <TableHeaderColumn>Date</TableHeaderColumn>
                                <TableHeaderColumn>Average Check-in</TableHeaderColumn>
                                <TableHeaderColumn>Total items checked-in</TableHeaderColumn>
                            </tr>
                        </TableHead>
                        <TableBody>
                            {
                                item.dailyView.map(function (daily, index) {
                                   return <tr key={index}>
                                        <TableRowColumn>{daily.createdDate}</TableRowColumn>
                                        <TableRowColumn>{daily.avgTime}</TableRowColumn>
                                        <TableRowColumn>{daily.items}</TableRowColumn>
                                    </tr>
                                })
                            }
                            <tr>
                                <TableHeaderColumn colSpan={3}>Total</TableHeaderColumn>
                            </tr>
                            <tr>
                                <TableHeaderColumn colSpan={2}>Average check-in time across the date range</TableHeaderColumn>
                                <TableHeaderColumn>Total items checked in across the date range</TableHeaderColumn>
                            </tr>
                            <tr>
                                <TableRowColumn colSpan={2}>{item.totalAvgTime}</TableRowColumn>
                                <TableRowColumn>{item.totalItems}</TableRowColumn>
                            </tr>
                        </TableBody>
                    </Table>;

                    return rowColumnComponent;
                });
            }
        } else {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList.push(<tr key="0"><td colSpan="8">{this.state.emptyTableMessage}</td></tr>);
            }
        }
        return rowColumnComponentList;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        /*downloadFileAction = {this.downloadFileAction}*/
                        /*selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}*/
                        type = "cannedReport"
                    >
                        <DatePicker
                            fieldId = "packageCheckInTimeStartDate"
                            placeHolderText = "Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "packageCheckInTimeEndDate"
                            placeHolderText = "End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                    </TableSearchHeader>
                    <TableBody>
                        {this.createTables()}
                    </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;